import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfile.scss'
import { Row, Col } from 'react-bootstrap'
import Rating from '../../../common/Rating'
import IsIndependent from '../../../common/AdviserProfiles/IsIndependent/IsIndependent'
import PrimaryActionButton from '../../../common/Buttons/PrimaryActionButton'
import AdviserProfilePictures from '../../../common/AdviserProfiles/AdviserProfilePictures'
import AdviserProfileInvestmentMinimums from '../../../common/AdviserProfiles/AdviserProfileInvestmentMinimums'
import AdviserProfileEducation from '../../../common/AdviserProfiles/AdviserProfileEducation'
import AdviserProfileWorkExperience from '../../../common/AdviserProfiles/AdviserProfileWorkExperience'
import AdviserProfileAreasOfSpecialisation from '../../../common/AdviserProfiles/AdviserProfileAreasOfSpecialisation'
import AdviserProfileLanguagePreferences from '../../../common/AdviserProfiles/AdviserProfileLanguagePreferences'
import AdviserProfileBlurb from '../../../common/AdviserProfiles/AdviserProfileBlurb'
import AdviserProfileClientPreferences from '../../../common/AdviserProfiles/AdviserProfileClientPreferences'
import DistanceToAdviser from '../../../common/DistanceToAdviser'
import PropTypes from 'prop-types';

class AdviserProfile extends React.Component {

  static propTypes = {
    profile: PropTypes.object.isRequired,
    contactAdviser: PropTypes.func.isRequired,
    rateAdviser: PropTypes.func.isRequired,
    investorLocation: PropTypes.string
  };

  render () {
    const profile = this.props.profile
    return (
      <Row>
        <Col sm={4} md={4} lg={3} className="d-none d-md-block">
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-md-block">
              <AdviserProfilePictures profilePicture={profile.profilePic} companyLogo={profile.companyLogo} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-md-block">
              <PrimaryActionButton
                className={styles['full-width']}
                buttonText={'Contact adviser'}
                onClick={this.props.contactAdviser} />
            </Col>
          </Row>
          <Row className={styles['padding-bottom']}>
            <Col sm={12} md={12} lg={12} className="d-none d-md-block">
              <Rating className={styles['ag-red']}
                average={profile?.rating?.average ?? 0}
                totalReviews={profile?.rating?.totalReviews ?? 0} />
              <a
                className={styles['rating-button']}
                onClick={this.props.rateAdviser}
                target='blank'>
                Rate this adviser
              </a>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-md-block">
              <IsIndependent
                isIndependent={profile.isIndependent}
                conflictDeclarations={profile.conflictDeclarations}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-md-block">
              <AdviserProfileLanguagePreferences languages={profile.languagePreferences} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-md-block">
              <AdviserProfileAreasOfSpecialisation areas={profile.financialServicesOffered} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-md-block">
              <AdviserProfileClientPreferences clientPreferences={profile.clientTypePreferences} />
            </Col>
          </Row>
        </Col>
        <Col sm={8} md={8} lg={9} className={`d-none d-md-block ${styles['padding-left-25']}`} >
          <Row>
            <Col sm={9} md={9} lg={9} className="d-none d-md-block">
              <AdviserProfileBlurb profile={profile} />
            </Col>
            <Col sm={3} md={3} lg={3} className={`d-none d-md-block ${styles['no-padding-left']}`}>
              <DistanceToAdviser
                fromLocation={this.props.investorLocation}
                toLocation={`${profile.streetAddress}, ${profile.suburb}, ${profile.city}, South Africa`}
                distanceToAdviser={profile.distanceToAdviser} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-md-block">
              <AdviserProfileInvestmentMinimums investmentMinimums={profile.investmentMinimums} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-md-block">
              <AdviserProfileEducation qualifications={profile.qualifications} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-md-block">
              <AdviserProfileWorkExperience experiences={profile.workExperiences} />
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default  (AdviserProfile)
